import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const outerTheme = createTheme({
  typography: {
    fontFamily: "AP",
    fontStyle: "normal",
    subtitle1: { fontSize: 18 },
  },
  palette: {
    primary: {
      main: "#c92028",
    },
    secondary: {
      main: "#292726",
    },
  },
  overrides: {
    MuiInput: {
      root: {},
      input: {
        color: "#292726",
        fontSize: 18,
        lineHeight: "32px",
        fontWeight: 400,
      },
      textarea: {
        color: "#292726",
        fontSize: 18,
        lineHeight: "32px",
        fontWeight: 400,
      },
    },
    MuiInputLabel: {
      color: "#292726",
      fontWeight: 800,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={outerTheme}>
    <App />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
